// ChiBadge -- colored pill showing a Customer Health Index score.
//
// Buckets (matches server/services/chiCalculator.bucket()):
//   >= 80  green   healthy
//   >= 50  amber   watch
//   >= 0   red     at risk
//   null           grey "no data" pill
//
// Usage:
//   <ChiBadge score={87} />             // Regular size
//   <ChiBadge score={12} size="lg" />   // Big header size
//   <ChiBadge score={null} />           // Grey placeholder

const COLORS = {
  green: { bg: '#d1fae5', border: '#6ee7b7', text: '#047857' },
  amber: { bg: '#fef3c7', border: '#fcd34d', text: '#b45309' },
  red:   { bg: '#fee2e2', border: '#fca5a5', text: '#b91c1c' },
  grey:  { bg: '#f3f4f6', border: '#e5e7eb', text: '#6b7280' },
};

function bucketFor(score) {
  if (score === null || score === undefined) return 'grey';
  if (score >= 80) return 'green';
  if (score >= 50) return 'amber';
  return 'red';
}

export default function ChiBadge({ score, size = 'md', title }) {
  const b = bucketFor(score);
  const c = COLORS[b];
  const label = score === null || score === undefined ? '—' : Math.round(score);
  const dims = size === 'lg'
    ? { padding: '4px 10px', fontSize: 15, minWidth: 44 }
    : size === 'sm'
    ? { padding: '1px 6px', fontSize: 10, minWidth: 26 }
    : { padding: '2px 8px', fontSize: 12, minWidth: 32 };

  const tooltip = title || (score === null
    ? 'CHI: no snapshot yet'
    : `CHI ${label} (${b}) — click customer for drill-down`);

  return (
    <span
      title={tooltip}
      className="chi-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: c.bg,
        color: c.text,
        border: `1px solid ${c.border}`,
        borderRadius: 999,
        fontWeight: 700,
        fontFamily: 'var(--font-mono)',
        letterSpacing: '0.02em',
        lineHeight: 1,
        ...dims,
      }}
    >
      {label}
    </span>
  );
}
